'use client'

import { FC, useState } from 'react'
import { Box, Button, Stack, Text, VStack } from '@chakra-ui/react'
import BottomSheet from '@/app/[locale]/_components/Sheet'
import { IBranch } from '@/app/[locale]/_types'
import { useSelector } from 'react-redux'
import { useSaveBranchData } from '@/app/[locale]/_hooks/useSaveBranchData'
import { useTranslations } from 'next-intl'
import { useBranchList } from '@/app/[locale]/_service/branch.service'
import { IRedux } from '@/app/[locale]/_store/types'
import Content from '@/app/[locale]/_components/Branches/_components/content'

interface Props {
  isOpen: boolean
  onClose: () => void
  afterConfirm?: () => void
}

const BranchSelectSheet: FC<Props> = ({ isOpen, onClose, afterConfirm }) => {
  const t = useTranslations()
  const saveBranch = useSaveBranchData()
  const { order_type } = useSelector((state: IRedux) => state.session)
  const { data: settingsData } = useSelector((state: IRedux) => state.settings)

  const [branch, setBranch] = useState<IBranch | null>(null)

  const { data } = useBranchList({
    params: {
      page: 1,
      limit: 100,
      order_type_id: order_type?.id,
    },
    props: { enabled: Boolean(settingsData?.choose_delivery_branch) },
  })

  const onConfirm = () => {
    if (branch) {
      saveBranch({
        id: branch.id,
        menu_id: branch.menu_id || '',
        address: branch.address,
        name: branch.name,
        location: branch.location,
        slug: branch.slug,
        future_delivery_order_time: branch.future_delivery_order_time,
        future_self_pickup_order_time: branch.future_self_pickup_order_time,
        delivery_time: branch.delivery_time,
        work_hour_start: branch.work_hour_start,
        work_hour_end: branch.work_hour_end,
        is_work_24_7: branch.is_work_24_7,
      })
      setBranch(null)
      onClose()

      if (afterConfirm) {
        afterConfirm?.()
      }
    }
  }

  return (
    <BottomSheet
      zIndex={1500}
      contentHeight='default'
      isOpen={isOpen}
      onClose={onClose}
    >
      <Stack h='100%' w='100%' gap={0}>
        <Text px={4} pb={2} fontSize={24} fontWeight={700}>
          {t('select_delivery_branch')}
        </Text>
        <VStack
          flex='1'
          alignItems='start'
          gap={4}
          px={4}
          w='100%'
          overflowY='auto'
        >
          <Content
            data={data?.branches}
            selectedBranch={branch}
            onSelectBranch={(branch) => {
              console.log('Selected:', branch)
            }}
            setSelectedBranch={setBranch}
          />
        </VStack>

        <Box bg='light' p={4} w='100%'>
          <Button
            fontSize={16}
            size='xl'
            height='56px'
            bg='primary'
            color='primary.text'
            _hover={{
              bg: 'primary.hover',
            }}
            w='full'
            rounded={16}
            onClick={onConfirm}
          >
            {t('select')}
          </Button>
        </Box>
      </Stack>
    </BottomSheet>
  )
}

export default BranchSelectSheet
